import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { User, Loader2 } from 'lucide-react';

export default function ProfileTab({ profile, setProfile, user, loading, onSave }) {
  return (
    <Card className="bg-white border-gray-border">
      <CardHeader>
        <CardTitle className="text-lg font-heading flex items-center gap-2">
          <User className="h-5 w-5 text-emerald-brand" />
          Profile Information
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="full_name">Full Name</Label>
            <Input id="full_name" value={profile.full_name || ''} onChange={(e) => setProfile(prev => ({ ...prev, full_name: e.target.value }))} className="mt-2" />
          </div>
          <div>
            <Label htmlFor="business_name">Business Name</Label>
            <Input id="business_name" value={profile.business_name || ''} onChange={(e) => setProfile(prev => ({ ...prev, business_name: e.target.value }))} className="mt-2" />
          </div>
          <div>
            <Label htmlFor="phone">Phone</Label>
            <Input id="phone" value={profile.phone || ''} onChange={(e) => setProfile(prev => ({ ...prev, phone: e.target.value }))} className="mt-2" />
          </div>
          <div>
            <Label htmlFor="industry">Industry</Label>
            <Input id="industry" value={profile.industry || ''} onChange={(e) => setProfile(prev => ({ ...prev, industry: e.target.value }))} className="mt-2" />
          </div>
        </div>
        <div>
          <Label>Email</Label>
          <Input value={user?.email || ''} disabled className="mt-2 bg-gray-50" />
        </div>
        <Button onClick={onSave} disabled={loading} className="bg-emerald-brand hover:bg-emerald-hover">
          {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
          Save Changes
        </Button>
      </CardContent>
    </Card>
  );
}
